<ng-container *ngIf="!tokenCheck">
  <div class="lp-telegram-header section-wrapper">
    <a href="https://app.atalef.ai/" class="lp-telegram-header__logo"></a>
    <a class="is-btn" (click)="goTelegram()">{{ 'LpTelegram.JoinNow' | translate }}</a>
  </div>
  <div class="lp-telegram">
    <div class="lp-telegram__inner section-wrapper">
      <div></div>
      <div class="lp-telegram__text">
        <div>
          <h1>{{ 'LpTelegram.Title' | translate }}</h1>
          <p>{{ 'LpTelegram.Description' | translate }}</p>
          <ul>
            <li>{{ 'LpTelegram.Feature1' | translate }}</li>
            <li>{{ 'LpTelegram.Feature2' | translate }}</li>
          </ul>
          <!-- <div class="lp-telegram__btns" *ngIf="!(isLoggedIn$ | async)">
            <div class="is-btn is-btn__outfill" (click)="login()">Join Now</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</ng-container>